import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledCode = styled.code`
    padding: 6px 12px;
    background-color: #F6F6F6;
    border: 1px solid #DADADA;
    border-radius: 4px;
    font-size: 14px;
    line-height: 3;
`;

const Code = (props) => {
    const { children } = props;

    return (
        <StyledCode>
            { children }
        </StyledCode>
    );
};

Code.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Code;



// WEBPACK FOOTER //
// ./src/components/ui/show/Code.js